import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-pool-group-config',
  standalone: false,
  templateUrl: './pool-group-config.component.html',
  styleUrls: ['./pool-group-config.component.scss']
})
export class PoolGroupConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor() { }

  ngOnInit() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'pool-group',
        approxamateRowCount: 1000,
        anyParams: true,
      },
      colConfig: [
        { field: 'poolId', header: 'Pool ID', type: ColumnType.String, isReadonly: true, isPrimary: true, notInForm: true },
        { field: 'poolName', header: 'Pool Name', type: ColumnType.String }
      ],
      addFormConfig: {
        header: 'Add User Pool Group'
      },
      isConfigurable: true,
      canEdit: false
    };
  }

}
